import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { ConfiguracionService } from '../../services/configuracion.service';
import { RespuestaGenerica } from '../../models/generic/RespuestaGenerica';
import { ConfirmacionGenericaComponent } from '../confirmaciongenerica/confirmaciongenerica.component';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import { Maestro_CargasArchivos } from '../../models/generic/Maestro_CargasArchivos';
import { Maestro_CargasArchivosRoles } from '../../models/generic/Maestro_CargasArchivosRoles';
import { Maestro_CargasArchivosUsuarios } from '../../models/generic/Maestro_CargasArchivosUsuarios';
import { Maestro_EstadoActualizar } from 'src/app/models/generic/Maestro_EstadoActualizar';
import { Maestros_CargasArchivosService } from 'src/app/services/maestros_cargasarchivos.service';
import { Maestro_CargasArchivos_Actualizacion } from 'src/app/models/generic/Maestro_CargasArchivos_Actualizacion';
import { Maestro_CargasArchivosCargaRecurrenteArchivos } from '../../models/generic/Maestro_CargasArchivosCargaRecurrenteArchivos';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Maestro_Aliados } from '../../models/generic/Maestro_Aliados';
import { Item_Seleccion } from 'src/app/models/generic/Item_Seleccion';
import { Maestro_CargaRecurrenteArchivosTitulos } from 'src/app/models/generic/Maestro_CargaRecurrenteArchivosTitulos';
import { Maestro_CargaRecurrenteArchivosBeneficiarios } from '../../models/generic/Maestro_CargaRecurrenteArchivosBeneficiarios';
import { Maestro_CargaRecurrenteArchivosBeneficiariosCampos } from 'src/app/models/generic/Maestro_CargaRecurrenteArchivosBeneficiariosCampos';
import { AdicionarItemsListaAdicionalesComponent } from '../adicionar-items-lista-adicionales/adicionar-items-lista-adicionales.component';
import { Maestro_Productos } from 'src/app/models/generic/Maestro_Productos';
import { Maestro_AliadosCanales } from 'src/app/models/generic/Maestro_AliadosCanales';

@Component({
  selector: 'maestros-cargasarchivos-editar',
  templateUrl: './maestros-cargasarchivos-editar.component.html',
  styleUrls: ['./maestros-cargasarchivos-editar.component.scss']
})
export class MaestrosCargasArchivosEditarComponent implements OnInit{
  APLICACION_CLIENTES_ALIADOS = 'CLIENTESALIADOS';
  TIPOEDICION_COLUMNA_VISUALIZAR = 'COLUMNAS_VISUALIZAR';
  TIPOEDICION_COLUMNA_BENEFICIARIOS = 'COLUMNAS_BENEFICIARIOS';
  TIPOEDICION_COLUMNA_BENEFICIARIOS_TITULOS = 'COLUMNAS_BENEFICIARIOS_TITULOS';
  TIPOEDICION_COLUMNA_FILTROEXTENSION = 'FILTROEXTENSION';


  form: FormGroup;
  tituloForma: string = 'Registro de ruta';
  tituloBoton: string = 'Registrar ruta';
  tituloBotonMigrarDatos: string = 'Migrar datos';
  mostrarCargando: boolean = false;
  listaDatosRoles: Maestro_CargasArchivosRoles[] = [];
  listaDatosUsuarios: Maestro_CargasArchivosUsuarios[] = [];
  listaDatosAplicaciones: Maestro_Aliados[] = [];
  listaDatosAplicacionesDestino: Maestro_Aliados[] = [];
  parametrosPrincipal: Maestro_CargasArchivos;
  codigoAccion: string = '';
  @ViewChild('appconfirmacion', {static: false}) _appconfirmacion: ConfirmacionGenericaComponent;
  @ViewChild('appvaloresposiblesmodal', {static: false}) _appvaloresposiblesmodal: AdicionarItemsListaAdicionalesComponent;
  listaEstado: Maestro_EstadoActualizar[] = [];
  listaExtensiones: Item_Seleccion[] = [];
  idTabSeleccionado: number = 0;
  listaCanales: Maestro_AliadosCanales[] = [];
  listaProductos: Maestro_Productos[] = [];

  detalleSeleccionado: number;
  formCargaRecurrenteArchivos: FormGroup;
  editarRegistroCargaRecurrenteArchivos: boolean = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSourceCargaRecurrenteArchivos: MatTableDataSource<Maestro_CargasArchivosCargaRecurrenteArchivos>;
  columnasEncabezadoCargaRecurrenteArchivos: string[] = ['id', 'tomarRutaPrincipal', 'rutaCargaArchivos', 'extensionLectura', 'cargaActiva', 'acciones'];
  listaDatosCargaRecurrenteArchivos: Maestro_CargasArchivosCargaRecurrenteArchivos[] = [];
  listaDatosCargaRecurrenteArchivosEliminar: Maestro_CargasArchivosCargaRecurrenteArchivos[] = [];
  cargaRecurrenteArchivosPrincipal: Maestro_CargasArchivosCargaRecurrenteArchivos;
  _EditarItemsVisualizar: string = '';
  ejecutarCambiosFormRecurrente: boolean = true;
  
  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public datosServices: Maestros_CargasArchivosService,
    public configuracionService: ConfiguracionService,
    public tamanoAppService: TamanoAppService) {}

  ngOnInit() {
    this.IniciarFormulario();
    this.listaEstado = [];
    this.listaExtensiones = [];

    this.listaEstado.push({ seleccionado: true, descripcion: 'Si' });
    this.listaEstado.push({ seleccionado: false, descripcion: 'No' });

    this.listaExtensiones.push(this.ItemExtensionRetorno('txt', 'TXT-PROCEDIMIENTO'));
    this.listaExtensiones.push(this.ItemExtensionRetorno('csv', 'CSV-PROCEDIMIENTO'));
    this.listaExtensiones.push(this.ItemExtensionRetorno('excelpro', 'EXCEL-PROCEDIMIENTO'));
    this.listaExtensiones.push(this.ItemExtensionRetorno('excel', 'EXCEL'));
    this.listaExtensiones.push(this.ItemExtensionRetorno('plano', 'PLANO'));
  }
  ItemExtensionRetorno(id: string, descripcion: string): Item_Seleccion {
    let itemRetorno: Item_Seleccion = new Item_Seleccion();
    itemRetorno.id = id;
    itemRetorno.descripcion = descripcion;
    return itemRetorno;
  }
  ngAfterViewInit() {
    this.utilitariosService.EstablecerTextoPaginado(this.paginator);
    
    if (this.utilitariosService.VerificarContieneDatos(this.menuService.ParametrosAdicionales)) {
      this.parametrosPrincipal = JSON.parse(this.menuService.ParametrosAdicionales);
      this.parametrosPrincipal.rolesSeleccionados = [];
      this.parametrosPrincipal.usuariosSeleccionados = [];

      // console.log('setea valor', this.parametrosPrincipal);
      this.form.setValue(this.parametrosPrincipal);
      
      this.tituloForma = 'Edición de ruta';
      this.tituloBoton = 'Editar ruta';
    } else {
      this.tituloForma = 'Registro de ruta';
      this.tituloBoton = 'Registrar ruta';
      this.parametrosPrincipal = new Maestro_CargasArchivos();
      this.parametrosPrincipal.id = 0;
    }
    this.ConsultarRegistrosRoles();
    this.ConsultarRegistrosUsuarios();
    this.ConsultarRegistrosCargaRecurrenciaArchivos();
    this.ConsultarRegistrosAplicaciones();
  }

  IniciarFormulario() {
    this.form = this.fb.group({
      id: [0],
      ruta: ['', [Validators.required, Validators.maxLength(5000)]],
      descripcion: ['', [Validators.required, Validators.maxLength(500)]],
      subirArchivo: [true],
      eliminar: [true],
      subdirectorios: [true],
      activo: [true],
      filtroArchivos: [''],
      rolesSeleccionados: [[]],
      usuariosSeleccionados: [[]],
    });

    this.IniciarFormularioCargaRecurrenteArchivos();
  }
  CancelarRegistro() {
    this.menuService.CambiarComponenteActivo('MaestrosCargasArchivosComponent');
  }
  ConfirmoUsuario(confirmo: boolean) {
    if (confirmo) {
      if (this.codigoAccion === 'guardar') {
        this.ActualizarRegistro();
      } else if (this.codigoAccion === 'migrardatos') {
        this.EjecutarMigrarDatos();
      } else {
        this.EliminarRegistroCargaRecurrenciaArchivos();
      }
    }
  }
  Guardar() {
    if (this.form.valid) {
      this.codigoAccion = 'guardar';
      this._appconfirmacion.MostrarMensajeConfirmacion();
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.form);
    }
  }
  ActualizarRegistro() {
    this.mostrarCargando = true;
    
    let listaRolesSeleccionados = this.form.get('rolesSeleccionados').value;
    let listaUsuariosSeleccionados = this.form.get('usuariosSeleccionados').value;

    for (let index = 0; index < this.listaDatosRoles.length; index++) {
      if (listaRolesSeleccionados.filter(x => x === this.listaDatosRoles[index].idRol).length > 0) {
        this.listaDatosRoles[index].seleccionado = true;
      } else {
        this.listaDatosRoles[index].seleccionado = false;
      }
    }

    for (let index = 0; index < this.listaDatosUsuarios.length; index++) {
      if (listaUsuariosSeleccionados.filter(x => x === this.listaDatosUsuarios[index].idUsuario).length > 0) {
        this.listaDatosUsuarios[index].seleccionado = true;
      } else {
        this.listaDatosUsuarios[index].seleccionado = false;
      }
    }
    
    let parametrosActualizacion: Maestro_CargasArchivos_Actualizacion = new Maestro_CargasArchivos_Actualizacion();
    parametrosActualizacion.principal = new Maestro_CargasArchivos();
    parametrosActualizacion.principal.id = this.form.get('id').value;
    parametrosActualizacion.principal.ruta = this.form.get('ruta').value;
    parametrosActualizacion.principal.descripcion = this.form.get('descripcion').value;
    parametrosActualizacion.principal.subirArchivo = this.form.get('subirArchivo').value;
    parametrosActualizacion.principal.eliminar = this.form.get('eliminar').value;
    parametrosActualizacion.principal.subdirectorios = this.form.get('subdirectorios').value;
    parametrosActualizacion.principal.activo = this.form.get('activo').value;
    parametrosActualizacion.principal.filtroArchivos = this.form.get('filtroArchivos').value;
    parametrosActualizacion.listaRoles = this.listaDatosRoles;
    parametrosActualizacion.listaUsuarios = this.listaDatosUsuarios;
    parametrosActualizacion.listaCargasRecurrencia = this.listaDatosCargaRecurrenteArchivos;
    parametrosActualizacion.listaCargasRecurrenciaEliminar = this.listaDatosCargaRecurrenteArchivosEliminar;

    this.datosServices.Actualizar(parametrosActualizacion)
            .subscribe((resp: RespuestaGenerica) =>{
              this.mostrarCargando = false;
              if (resp.procesoExitoso == false) {
                this.utilitariosService.MensajeToast(resp.mensaje);
              } else {
                this.menuService.CambiarComponenteActivo('MaestrosCargasArchivosComponent');
              }
            },
            (error: Error) => {
              this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
              this.mostrarCargando = false;
              this.cd.detectChanges();
            },
            () => this.cd.detectChanges());
  }
  ConsultarRegistrosRoles() {
    this.mostrarCargando = true;
    this.datosServices.Roles_Consultar(this.parametrosPrincipal.id)
              .subscribe((resp: Maestro_CargasArchivosRoles[]) =>{
                this.mostrarCargando = false;
                this.listaDatosRoles = resp;
                this.parametrosPrincipal.rolesSeleccionados = [];
                
                for (let index = 0; index < this.listaDatosRoles.length; index++) {
                  if (this.listaDatosRoles[index].seleccionado) {
                    this.parametrosPrincipal.rolesSeleccionados.push(this.listaDatosRoles[index].idRol);
                  }
                }
                this.form.get('rolesSeleccionados').setValue(this.parametrosPrincipal.rolesSeleccionados);
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  ConsultarRegistrosUsuarios() {
    this.mostrarCargando = true;
    this.datosServices.Usuarios_Consultar(this.parametrosPrincipal.id)
              .subscribe((resp: Maestro_CargasArchivosUsuarios[]) =>{
                this.mostrarCargando = false;
                this.listaDatosUsuarios = resp;
                this.parametrosPrincipal.usuariosSeleccionados = [];
                
                for (let index = 0; index < this.listaDatosUsuarios.length; index++) {
                  if (this.listaDatosUsuarios[index].seleccionado) {
                    this.parametrosPrincipal.usuariosSeleccionados.push(this.listaDatosUsuarios[index].idUsuario);
                  }
                }
                this.form.get('usuariosSeleccionados').setValue(this.parametrosPrincipal.usuariosSeleccionados);
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  ConsultarRegistrosCargaRecurrenciaArchivos() {
    this.mostrarCargando = true;
    this.datosServices.CargaRecurrenteArchivos_Consultar(this.parametrosPrincipal.id)
              .subscribe((resp: Maestro_CargasArchivosCargaRecurrenteArchivos[]) =>{
                this.mostrarCargando = false;
                this.listaDatosCargaRecurrenteArchivos = resp;
                this.recargarListaCargaRecurrenciaArchivos();
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  ConsultarRegistrosAplicaciones() {
    this.mostrarCargando = true;
    let parametrosConsulta: FormGroup = new FormGroup({
      'filtro': new FormControl('')
    });
    this.datosServices.Aplicaciones_Consultar(parametrosConsulta.value)
              .subscribe((resp: Maestro_Aliados[]) =>{
                this.mostrarCargando = false;
                this.listaDatosAplicaciones = resp;
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  tabSeleccionado(item: any) {
    this.idTabSeleccionado = item.index;    
  }

  IniciarFormularioCargaRecurrenteArchivos() {
    this.formCargaRecurrenteArchivos = this.fb.group({
      id: [0],
      cargaActiva: [true],
      rutaCargaArchivos: ['', [Validators.maxLength(500)]],
      rutaMoverArchivos: ['', [Validators.maxLength(500)]],
      rutaBulkInsert: ['', [Validators.maxLength(500)]],
      rutaFormato: ['', [Validators.maxLength(500)]],
      rutaBackupCargaArchivos: ['', [Validators.required, Validators.maxLength(500)]],
      procedimientoCargaEnOrigen: ['', [Validators.maxLength(500)]],
      tomarRutaPrincipal: [true],
      extensionLectura: ['', [Validators.required, Validators.maxLength(10)]],
      aplicacion: [null, [Validators.required]],
      clienteCarga: [''],
      archivoCarga: [''],
      archivoProducto: [''],
      columnaIdentificacion: [''],
      columnaNombre: [''],
      columnaRegistroUnico: [''],
      columnaFechaInicial: [''],
      columnaFechaFinal: [''],
      columnasVisualizar: [''],
      mostrarBeneficiarios: [false],
      columnasBeneficiarios: [''],
      columnaApellido: [''],
      extensionesFiltro: [''],
      separadorColumnas: [''],
      rutaTerminosCondiciones: [''],
      rutaControlOperaciones: [''],
      idAplicacionDestino: [0],
      idProducto: [0],
      columnaEmail: [''],
      columnaNroMovil: [''],
      ocultarEstadisticas: [false],
      idCanal: [0],
    });

    this.formCargaRecurrenteArchivos.get('tomarRutaPrincipal').valueChanges.subscribe(valorNuevo => {
      let validatorsCampo = [];
  
      validatorsCampo.push(Validators.maxLength(500));
      if (!valorNuevo) {  
        validatorsCampo.push(Validators.required);
      } else {
        this.formCargaRecurrenteArchivos.get('rutaCargaArchivos').setValue('');
      }
  
      this.formCargaRecurrenteArchivos.get('rutaCargaArchivos').setValidators(validatorsCampo);
      this.formCargaRecurrenteArchivos.get('rutaCargaArchivos').updateValueAndValidity();
    });

    this.formCargaRecurrenteArchivos.get('extensionLectura').valueChanges.subscribe(valorNuevo => {
      let validatorsCampoExcel1 = [];
      let validatorsCampoExcel2 = [];
      let validatorsCampoPlano = [];
      let validatorsCampoExtensionesFiltro = [];

      validatorsCampoExcel1.push(Validators.maxLength(5000));
      validatorsCampoExcel2.push(Validators.maxLength(100));
      validatorsCampoPlano.push(Validators.maxLength(500));
      
      if (valorNuevo === 'excel' || valorNuevo === 'plano') {
        validatorsCampoExcel1.push(Validators.required);
        validatorsCampoExcel2.push(Validators.required);

        if (valorNuevo === 'plano') {
          validatorsCampoExtensionesFiltro.push(Validators.required);
        }

        this.formCargaRecurrenteArchivos.get('rutaBulkInsert').setValue('');
        this.formCargaRecurrenteArchivos.get('rutaMoverArchivos').setValue('');
        this.formCargaRecurrenteArchivos.get('rutaFormato').setValue('');
        this.formCargaRecurrenteArchivos.get('procedimientoCargaEnOrigen').setValue('');
      } else {
        validatorsCampoPlano.push(Validators.required);

        this.formCargaRecurrenteArchivos.get('clienteCarga').setValue('');
        this.formCargaRecurrenteArchivos.get('archivoCarga').setValue('');
        this.formCargaRecurrenteArchivos.get('archivoProducto').setValue('');
        this.formCargaRecurrenteArchivos.get('columnaIdentificacion').setValue('');
        this.formCargaRecurrenteArchivos.get('columnaNombre').setValue('');
        this.formCargaRecurrenteArchivos.get('columnaRegistroUnico').setValue('');
        this.formCargaRecurrenteArchivos.get('columnaFechaInicial').setValue('');
        this.formCargaRecurrenteArchivos.get('columnaFechaFinal').setValue('');
        this.formCargaRecurrenteArchivos.get('columnasVisualizar').setValue('');
        this.formCargaRecurrenteArchivos.get('mostrarBeneficiarios').setValue(false);
        this.formCargaRecurrenteArchivos.get('columnasBeneficiarios').setValue('');
        this.formCargaRecurrenteArchivos.get('columnaApellido').setValue('');
        this.formCargaRecurrenteArchivos.get('extensionesFiltro').setValue('');
        this.formCargaRecurrenteArchivos.get('separadorColumnas').setValue('');
        this.formCargaRecurrenteArchivos.get('rutaTerminosCondiciones').setValue('');
        this.formCargaRecurrenteArchivos.get('rutaControlOperaciones').setValue('');
        this.formCargaRecurrenteArchivos.get('idAplicacionDestino').setValue(0);
        this.formCargaRecurrenteArchivos.get('idProducto').setValue(0);
        this.formCargaRecurrenteArchivos.get('columnaEmail').setValue('');
        this.formCargaRecurrenteArchivos.get('columnaNroMovil').setValue('');
        this.formCargaRecurrenteArchivos.get('ocultarEstadisticas').setValue(false);
        this.formCargaRecurrenteArchivos.get('idCanal').setValue(0);
      }
  
      this.formCargaRecurrenteArchivos.get('rutaBulkInsert').setValidators(validatorsCampoPlano);
      this.formCargaRecurrenteArchivos.get('rutaBulkInsert').updateValueAndValidity();

      this.formCargaRecurrenteArchivos.get('rutaMoverArchivos').setValidators(validatorsCampoPlano);
      this.formCargaRecurrenteArchivos.get('rutaMoverArchivos').updateValueAndValidity();

      this.formCargaRecurrenteArchivos.get('rutaFormato').setValidators(validatorsCampoPlano);
      this.formCargaRecurrenteArchivos.get('rutaFormato').updateValueAndValidity();

      this.formCargaRecurrenteArchivos.get('procedimientoCargaEnOrigen').setValidators(validatorsCampoPlano);
      this.formCargaRecurrenteArchivos.get('procedimientoCargaEnOrigen').updateValueAndValidity();

      this.formCargaRecurrenteArchivos.get('clienteCarga').setValidators(validatorsCampoExcel2);
      this.formCargaRecurrenteArchivos.get('clienteCarga').updateValueAndValidity();

      this.formCargaRecurrenteArchivos.get('archivoCarga').setValidators(validatorsCampoExcel2);
      this.formCargaRecurrenteArchivos.get('archivoCarga').updateValueAndValidity();

      this.formCargaRecurrenteArchivos.get('archivoProducto').setValidators(validatorsCampoExcel2);
      this.formCargaRecurrenteArchivos.get('archivoProducto').updateValueAndValidity();

      this.formCargaRecurrenteArchivos.get('columnaIdentificacion').setValidators(validatorsCampoExcel2);
      this.formCargaRecurrenteArchivos.get('columnaIdentificacion').updateValueAndValidity();

      this.formCargaRecurrenteArchivos.get('columnaNombre').setValidators(validatorsCampoExcel2);
      this.formCargaRecurrenteArchivos.get('columnaNombre').updateValueAndValidity();

      this.formCargaRecurrenteArchivos.get('columnaFechaInicial').setValidators(validatorsCampoExcel2);
      this.formCargaRecurrenteArchivos.get('columnaFechaInicial').updateValueAndValidity();

      this.formCargaRecurrenteArchivos.get('columnaFechaFinal').setValidators(validatorsCampoExcel2);
      this.formCargaRecurrenteArchivos.get('columnaFechaFinal').updateValueAndValidity();

      this.formCargaRecurrenteArchivos.get('extensionesFiltro').setValidators(validatorsCampoExtensionesFiltro);
      this.formCargaRecurrenteArchivos.get('extensionesFiltro').updateValueAndValidity();

      this.formCargaRecurrenteArchivos.get('separadorColumnas').setValidators(validatorsCampoExtensionesFiltro);
      this.formCargaRecurrenteArchivos.get('separadorColumnas').updateValueAndValidity();

      if (this.formCargaRecurrenteArchivos.get('mostrarBeneficiarios').value) {
        this.formCargaRecurrenteArchivos.get('columnasBeneficiarios').setValidators(validatorsCampoExcel1);
        this.formCargaRecurrenteArchivos.get('columnasBeneficiarios').updateValueAndValidity();
      }
    });

    this.formCargaRecurrenteArchivos.get('mostrarBeneficiarios').valueChanges.subscribe(valorNuevo => {
      let validatorsCampoExcel1 = [];
      validatorsCampoExcel1.push(Validators.maxLength(5000));
      
      if (valorNuevo) {
        validatorsCampoExcel1.push(Validators.required);
      } else {
        this.formCargaRecurrenteArchivos.get('columnasBeneficiarios').setValue('');
      }

      this.formCargaRecurrenteArchivos.get('columnasBeneficiarios').setValidators(validatorsCampoExcel1);
      this.formCargaRecurrenteArchivos.get('columnasBeneficiarios').updateValueAndValidity();
    });

    this.formCargaRecurrenteArchivos.get('idAplicacionDestino').valueChanges.subscribe(valorNuevo => {
      if (this.ejecutarCambiosFormRecurrente) {
        if (this.utilitariosService.VerificarContieneDatosNumerico(this.formCargaRecurrenteArchivos.get('idCanal').value)) {
          this.formCargaRecurrenteArchivos.get('idCanal').setValue(0);
        }
        this.ConsultarCanales(valorNuevo);
      }
    });
    this.formCargaRecurrenteArchivos.get('aplicacion').valueChanges.subscribe(valorNuevo => {
      if (this.ejecutarCambiosFormRecurrente) {
        if (this.utilitariosService.VerificarContieneDatosNumerico(this.formCargaRecurrenteArchivos.get('idCanal').value)) {
          this.formCargaRecurrenteArchivos.get('idCanal').setValue(0);
        }
        this.ConsultarCanales(valorNuevo);
      }
    });

    this.formCargaRecurrenteArchivos.get('idCanal').valueChanges.subscribe(valorNuevo => {
      if (this.ejecutarCambiosFormRecurrente) {
        if (this.utilitariosService.VerificarContieneDatosNumerico(this.formCargaRecurrenteArchivos.get('idProducto').value)) {
          this.formCargaRecurrenteArchivos.get('idProducto').setValue(0);
        }
        if (this.MostrarMigrarDatosDestino()) {
          this.ConsultarProductos(this.formCargaRecurrenteArchivos.get('idAplicacionDestino').value, valorNuevo);
        } else {
          this.ConsultarProductos(this.formCargaRecurrenteArchivos.get('aplicacion').value, valorNuevo);
        }
      }
    });
  }
  recargarListaCargaRecurrenciaArchivos() {
    this.dataSourceCargaRecurrenteArchivos = new MatTableDataSource(this.listaDatosCargaRecurrenteArchivos);
    this.dataSourceCargaRecurrenteArchivos.paginator = this.paginator;
    this.dataSourceCargaRecurrenteArchivos.sort = this.sort;
  }
  NuevoCargaRecurrenciaArchivos() {
    this.editarRegistroCargaRecurrenteArchivos = true;
    this.IniciarFormularioCargaRecurrenteArchivos();
    this.formCargaRecurrenteArchivos.get('id').setValue((this.listaDatosCargaRecurrenteArchivos.length + 1) * -1);
    
    if (this.MostrarMigrarDatosDestino()) {
      this.ConsultarCanales(this.formCargaRecurrenteArchivos.get('idAplicacionDestino').value);
    } else {
      this.ConsultarCanales(this.formCargaRecurrenteArchivos.get('aplicacion').value);
    }
    this.CargarListaAplicacionesDestino();
  }
  EditarCargaRecurrenciaArchivos(parametroEditar: Maestro_CargasArchivosCargaRecurrenteArchivos) {
    this.editarRegistroCargaRecurrenteArchivos = true;
    this.ejecutarCambiosFormRecurrente = false;
    this.formCargaRecurrenteArchivos.setValue(parametroEditar);
    this.ejecutarCambiosFormRecurrente = true;

    if (this.MostrarMigrarDatosDestino()) {
      this.ConsultarCanales(this.formCargaRecurrenteArchivos.get('idAplicacionDestino').value);
    } else {
      this.ConsultarCanales(this.formCargaRecurrenteArchivos.get('aplicacion').value);
    }
    this.CargarListaAplicacionesDestino();
  }
  EliminarCargaRecurrenciaArchivos(parametroEditar: Maestro_CargasArchivosCargaRecurrenteArchivos) {
    this.detalleSeleccionado = parametroEditar.id;
    this.codigoAccion = 'eliminarParametro';
    this._appconfirmacion.MostrarMensajeConfirmacion();
  }
  GuardarCargaRecurrenciaArchivos() {
    if (this.formCargaRecurrenteArchivos.valid) {
      this.editarRegistroCargaRecurrenteArchivos = false;
      if (this.listaDatosCargaRecurrenteArchivos.filter(x => x.id === this.formCargaRecurrenteArchivos.get('id').value).length > 0) {
        let parametroActualizar = this.listaDatosCargaRecurrenteArchivos.filter(x => x.id === this.formCargaRecurrenteArchivos.get('id').value)[0];
        parametroActualizar.cargaActiva = this.formCargaRecurrenteArchivos.get('cargaActiva').value;
        parametroActualizar.extensionLectura = this.formCargaRecurrenteArchivos.get('extensionLectura').value;
        parametroActualizar.procedimientoCargaEnOrigen = this.formCargaRecurrenteArchivos.get('procedimientoCargaEnOrigen').value;
        parametroActualizar.rutaBackupCargaArchivos = this.formCargaRecurrenteArchivos.get('rutaBackupCargaArchivos').value;
        parametroActualizar.rutaBulkInsert = this.formCargaRecurrenteArchivos.get('rutaBulkInsert').value;
        parametroActualizar.rutaCargaArchivos = this.formCargaRecurrenteArchivos.get('rutaCargaArchivos').value;
        parametroActualizar.rutaFormato = this.formCargaRecurrenteArchivos.get('rutaFormato').value;
        parametroActualizar.rutaMoverArchivos = this.formCargaRecurrenteArchivos.get('rutaMoverArchivos').value;
        parametroActualizar.tomarRutaPrincipal = this.formCargaRecurrenteArchivos.get('tomarRutaPrincipal').value;
        parametroActualizar.clienteCarga = this.formCargaRecurrenteArchivos.get('clienteCarga').value;
        parametroActualizar.archivoCarga = this.formCargaRecurrenteArchivos.get('archivoCarga').value;
        parametroActualizar.archivoProducto = this.formCargaRecurrenteArchivos.get('archivoProducto').value;
        parametroActualizar.columnaIdentificacion = this.formCargaRecurrenteArchivos.get('columnaIdentificacion').value;
        parametroActualizar.columnaNombre = this.formCargaRecurrenteArchivos.get('columnaNombre').value;
        parametroActualizar.columnaRegistroUnico = this.formCargaRecurrenteArchivos.get('columnaRegistroUnico').value;
        parametroActualizar.columnaFechaInicial = this.formCargaRecurrenteArchivos.get('columnaFechaInicial').value;
        parametroActualizar.columnaFechaFinal = this.formCargaRecurrenteArchivos.get('columnaFechaFinal').value;
        parametroActualizar.columnasVisualizar = this.formCargaRecurrenteArchivos.get('columnasVisualizar').value;
        parametroActualizar.mostrarBeneficiarios = this.formCargaRecurrenteArchivos.get('mostrarBeneficiarios').value;
        parametroActualizar.columnasBeneficiarios = this.formCargaRecurrenteArchivos.get('columnasBeneficiarios').value;
        parametroActualizar.columnaApellido = this.formCargaRecurrenteArchivos.get('columnaApellido').value;
        parametroActualizar.aplicacion = this.formCargaRecurrenteArchivos.get('aplicacion').value;
        parametroActualizar.extensionesFiltro = this.formCargaRecurrenteArchivos.get('extensionesFiltro').value;
        parametroActualizar.separadorColumnas = this.formCargaRecurrenteArchivos.get('separadorColumnas').value;
        parametroActualizar.rutaTerminosCondiciones = this.formCargaRecurrenteArchivos.get('rutaTerminosCondiciones').value;
        parametroActualizar.rutaControlOperaciones = this.formCargaRecurrenteArchivos.get('rutaControlOperaciones').value;
        parametroActualizar.idAplicacionDestino = this.formCargaRecurrenteArchivos.get('idAplicacionDestino').value;
        parametroActualizar.idProducto = this.formCargaRecurrenteArchivos.get('idProducto').value;
        parametroActualizar.columnaEmail = this.formCargaRecurrenteArchivos.get('columnaEmail').value;
        parametroActualizar.columnaNroMovil = this.formCargaRecurrenteArchivos.get('columnaNroMovil').value;
        parametroActualizar.ocultarEstadisticas = this.formCargaRecurrenteArchivos.get('ocultarEstadisticas').value;
        parametroActualizar.idCanal = this.formCargaRecurrenteArchivos.get('idCanal').value;
      } else {
        this.listaDatosCargaRecurrenteArchivos.push(this.formCargaRecurrenteArchivos.value);
      }
      
      this.recargarListaCargaRecurrenciaArchivos();
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.formCargaRecurrenteArchivos);
    }
  }
  CancelarEditarCargaRecurrenciaArchivos() {
    this.editarRegistroCargaRecurrenteArchivos = false;
  }
  EliminarRegistroCargaRecurrenciaArchivos() {
    if (this.detalleSeleccionado > 0) {
      this.listaDatosCargaRecurrenteArchivosEliminar.push(this.listaDatosCargaRecurrenteArchivos.filter(x => x.id === this.detalleSeleccionado)[0]);
    }
    let listaNueva: Maestro_CargasArchivosCargaRecurrenteArchivos[] = [];
    for (let index = 0; index < this.listaDatosCargaRecurrenteArchivos.length; index++) {
      if (this.listaDatosCargaRecurrenteArchivos[index].id !== this.detalleSeleccionado) {
        listaNueva.push(this.listaDatosCargaRecurrenteArchivos[index]);
      }
    }
    this.listaDatosCargaRecurrenteArchivos = listaNueva;
    this.recargarListaCargaRecurrenciaArchivos();
  }
  SeleccionoValoresPosibles(valoresPosibles: string) {
    console.log('SeleccionoValoresPosibles', valoresPosibles);
    if (this._EditarItemsVisualizar === this.TIPOEDICION_COLUMNA_VISUALIZAR) {
      let listaCargas: Maestro_CargaRecurrenteArchivosTitulos[] = [];
      let itemsFilas = valoresPosibles.split('|');
      for (let index = 0; index < itemsFilas.length; index++) {
        let item = itemsFilas[index].split('*');
        listaCargas.push({ campo: item[0], titulo: item[1] });
      }

      this.formCargaRecurrenteArchivos.get('columnasVisualizar').setValue(JSON.stringify(listaCargas));
    } else if (this._EditarItemsVisualizar === this.TIPOEDICION_COLUMNA_BENEFICIARIOS) {
      let listaCargas: Maestro_CargaRecurrenteArchivosBeneficiarios[] = [];
      let itemsFilas = valoresPosibles.split('|');
      for (let index = 0; index < itemsFilas.length; index++) {
        let item = itemsFilas[index].split('*');
        let itemsColumnas = item[1].split('&');
        let listaColumnas: Maestro_CargaRecurrenteArchivosBeneficiariosCampos[] = [];
        for (let index = 0; index < itemsColumnas.length; index++) {
          listaColumnas.push({ campo: itemsColumnas[index] });
        }

        listaCargas.push({ titulo: item[0], columnas: listaColumnas });
      }

      this.formCargaRecurrenteArchivos.get('columnasBeneficiarios').setValue(JSON.stringify(listaCargas));
    } else if (this._EditarItemsVisualizar === this.TIPOEDICION_COLUMNA_FILTROEXTENSION) {
      let listaCargas: string[] = [];
      let itemsFilas = valoresPosibles.split('|');
      for (let index = 0; index < itemsFilas.length; index++) {
        listaCargas.push(itemsFilas[index]);
      }

      this.formCargaRecurrenteArchivos.get('extensionesFiltro').setValue(JSON.stringify(listaCargas));
    }
  }
  EditarParametroValoresPosiblesAdicionalesVisualizar() {
    let listaCargas: Maestro_CargaRecurrenteArchivosTitulos[] = [];
    let itemsModificar: string = '';

    if (this.utilitariosService.VerificarContieneDatosTexto(this.formCargaRecurrenteArchivos.get('columnasVisualizar').value)) {
      listaCargas = JSON.parse(this.formCargaRecurrenteArchivos.get('columnasVisualizar').value)
    }

    for (let index = 0; index < listaCargas.length; index++) {
      if (itemsModificar === '') {
        itemsModificar = `${listaCargas[index].campo}*${listaCargas[index].titulo}`;
      } else {
        itemsModificar += `|${listaCargas[index].campo}*${listaCargas[index].titulo}`;
      }
    }
    
    this._EditarItemsVisualizar = this.TIPOEDICION_COLUMNA_VISUALIZAR;
    this._appvaloresposiblesmodal.MostrarEdicionItemsListaConAdicionales(itemsModificar, '|', '*', true, false);
  }
  EditarParametroValoresPosiblesColumnasBeneficiarios() {
    let listaCargas: Maestro_CargaRecurrenteArchivosBeneficiarios[] = [];
    let itemsModificar: string = '';

    if (this.utilitariosService.VerificarContieneDatosTexto(this.formCargaRecurrenteArchivos.get('columnasBeneficiarios').value)) {
      listaCargas = JSON.parse(this.formCargaRecurrenteArchivos.get('columnasBeneficiarios').value)
    }

    for (let index = 0; index < listaCargas.length; index++) {
      let itemTitulo = listaCargas[index];
      let columnasAdicionar: string = '';
      for (let index2 = 0; index2 < itemTitulo.columnas.length; index2++) {
        let itemColumna = itemTitulo.columnas[index2].campo;
        
        if (columnasAdicionar === '') {
          columnasAdicionar = itemColumna;
        } else {
          columnasAdicionar += `&${itemColumna}`;
        }
      }
      if (itemsModificar === '') {
        itemsModificar = `${itemTitulo.titulo}*${columnasAdicionar}`;
      } else {
        itemsModificar += `|${itemTitulo.titulo}*${columnasAdicionar}`;
      }
    }

    this._EditarItemsVisualizar = this.TIPOEDICION_COLUMNA_BENEFICIARIOS;
    this._appvaloresposiblesmodal.MostrarEdicionItemsListaConAdicionales(itemsModificar, '|', '*', false, true);
  }
  EsExcelPlano(): boolean {
    return this.formCargaRecurrenteArchivos.get('extensionLectura').value === 'excel' || this.formCargaRecurrenteArchivos.get('extensionLectura').value === 'plano';
  }
  EsPlano(): boolean {
    return this.formCargaRecurrenteArchivos.get('extensionLectura').value === 'plano';
  }
  EditarParametroValoresPosiblesExtensionesFiltro() {
    let listaCargas: string[] = [];
    let itemsModificar: string = '';

    if (this.utilitariosService.VerificarContieneDatosTexto(this.formCargaRecurrenteArchivos.get('extensionesFiltro').value)) {
      listaCargas = JSON.parse(this.formCargaRecurrenteArchivos.get('extensionesFiltro').value)
    }

    for (let index = 0; index < listaCargas.length; index++) {
      let itemTitulo = listaCargas[index];
      if (itemsModificar === '') {
        itemsModificar = itemTitulo;
      } else {
        itemsModificar += `|${itemTitulo}`;
      }
    }

    this._EditarItemsVisualizar = this.TIPOEDICION_COLUMNA_FILTROEXTENSION;
    this._appvaloresposiblesmodal.MostrarEdicionItemsLista(itemsModificar);
  }
  MigrarDatos(itemSeleccionado: Maestro_CargasArchivosCargaRecurrenteArchivos) {
    if (this.utilitariosService.VerificarContieneDatosNumerico(itemSeleccionado.idAplicacionDestino) 
        && this.utilitariosService.VerificarContieneDatosNumerico(itemSeleccionado.idProducto)) {
      this.codigoAccion = 'migrardatos';
      this.cargaRecurrenteArchivosPrincipal = itemSeleccionado;
      this._appconfirmacion.MostrarMensajeConfirmacion();
    } else {
      this.utilitariosService.MensajeToast(`El registro no tiene seleccionado ningún producto.`);
    }
  }
  EjecutarMigrarDatos() {
    this.mostrarCargando = true;
    this.datosServices.CargaRecurrenteArchivos_MigrarDatos(this.cargaRecurrenteArchivosPrincipal)
            .subscribe((resp: RespuestaGenerica) =>{
              this.mostrarCargando = false;
              this.utilitariosService.MensajeToast(resp.mensaje);
            },
            (error: Error) => {
              this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
              this.mostrarCargando = false;
              this.cd.detectChanges();
            },
            () => this.cd.detectChanges());
  }
  ConsultarCanales(idAplicacionDestino: number) {
    this.listaProductos = [];

    if (this.utilitariosService.VerificarContieneDatosNumerico(idAplicacionDestino)) {
      let parametrosConsulta = this.fb.group({
        idAplicacionDestino: [0],
      });
  
      parametrosConsulta.get('idAplicacionDestino').setValue(idAplicacionDestino);
  
      this.datosServices.CargaRecurrenteArchivos_ConsultarCanales(parametrosConsulta.value)
                .subscribe((resp: Maestro_AliadosCanales[]) =>{
                  this.listaCanales = resp;
                  if (this.listaCanales.filter(x => x.id === this.formCargaRecurrenteArchivos.get('idCanal').value).length === 0) {
                    this.formCargaRecurrenteArchivos.get('idCanal').setValue(0);
                  }
                  
                  this.ConsultarProductos(idAplicacionDestino, this.formCargaRecurrenteArchivos.get('idCanal').value);
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
    }
  }
  ConsultarProductos(idAplicacionDestino: number, idCanal: number) {
    this.listaProductos = [];

    if (this.utilitariosService.VerificarContieneDatosNumerico(idAplicacionDestino)
      && this.utilitariosService.VerificarContieneDatosNumerico(idCanal)) {
      let parametrosConsulta = this.fb.group({
        idAplicacionDestino: [0],
        idCanalDestino: [0],
      });
  
      parametrosConsulta.get('idAplicacionDestino').setValue(idAplicacionDestino);
      parametrosConsulta.get('idCanalDestino').setValue(idCanal);
  
      this.datosServices.CargaRecurrenteArchivos_ConsultarProductos(parametrosConsulta.value)
                .subscribe((resp: Maestro_Productos[]) =>{
                  this.listaProductos = resp;
                  if (this.listaProductos.filter(x => x.id === this.formCargaRecurrenteArchivos.get('idProducto').value).length === 0) {
                    this.formCargaRecurrenteArchivos.get('idProducto').setValue(0);
                  }
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
    }
  }
  MostrarMigrarDatosDestino(): boolean {
    if (this.utilitariosService.VerificarContieneDatosLista(this.listaDatosAplicaciones)) {
      let itemAplicacion = this.listaDatosAplicaciones.filter(x => x.idAplicacion === this.formCargaRecurrenteArchivos.get('aplicacion').value);
      if (this.utilitariosService.VerificarContieneDatosLista(itemAplicacion)) {
        if (itemAplicacion[0].nombre === this.APLICACION_CLIENTES_ALIADOS) {
          return true;
        }
      }
    }
    return false;
  }
  MostrarMigrarDatosDestinoRegistro(itemSeleccionado: Maestro_CargasArchivosCargaRecurrenteArchivos): boolean {
    if (this.utilitariosService.VerificarContieneDatosLista(this.listaDatosAplicaciones)) {
      let itemAplicacion = this.listaDatosAplicaciones.filter(x => x.idAplicacion === itemSeleccionado.aplicacion);
      if (this.utilitariosService.VerificarContieneDatosLista(itemAplicacion)) {
        if (itemAplicacion[0].nombre === this.APLICACION_CLIENTES_ALIADOS) {
          return true;
        }
      }
    }
    return false;
  }
  CargarListaAplicacionesDestino() {
    let listaDatosAplicacionesAsignar: Maestro_Aliados[] = [];

    for (let index = 0; index < this.listaDatosAplicaciones.length; index++) {
      let itemAplicacion = this.listaDatosAplicaciones[index];
      if (itemAplicacion.nombre !== this.APLICACION_CLIENTES_ALIADOS) {
        listaDatosAplicacionesAsignar.push(itemAplicacion);
      }
    }

    this.listaDatosAplicacionesDestino = listaDatosAplicacionesAsignar;
  }
}
